/** @module csi/widget/_svg/AddPage */
define([
	"dijit/_WidgetBase",
	"dijit/_TemplatedMixin",
	"dijit/form/ComboButton",
	"csi/locale",
	"./_Plugin",
	"./PluginFactory",
	"./util",
	"./_AddPageDropDown",
], function (_WidgetBase, _TemplatedMixin, ComboButton, locale, _Plugin, PluginFactory, svgUtil, _AddPageDropDown) {

	return PluginFactory.declare([ComboButton, _Plugin], {
		materialIcon: "note_add",
		pluginName: "addPage",
		title: "CanvasAddPage",

		/**
		 * @override
		 * Attach drop down to button
		 */
		postCreate: function () {
			this.dropDown = new _AddPageDropDown({
				editor: this.editor,
			});

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add tooltip for the right portion of the button(arrow part)
		 */
		postMixInProperties: function () {
			this.inherited(arguments);

			this.optionsTitle = locale.resource("Templates");
		},

		/** 
		 * @override
		 * Override onBlur because when display is set to none on dropdown child it causes popup to lose focus
		 */
		_onBlur: function () {
			const { dropDown } = this;
			// if bShow was set to true, refocus and set bShow to false to restore blur functionality
			if (dropDown.bShow) {
				this.focusNode.focus();
				dropDown.bShow = false;
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * Click handler for AddPage
		 * If canvas pages are at max, show error, otherwise, add a new page
		 */
		onClick: function () {
			const view = this.getView();
			if (view.hasMaxPages()) {
				// show max pages reached dialog
				svgUtil.popupMaxPageErrorMessage();
			} else {
				view.addPage();
			}
		}
	});
});
